<template>
    <div
        class="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700 p-5 hover:shadow-md transition-shadow dark:shadow-slate-900/50 cursor-pointer"
        @click="openBooking"
    >
        <div class="flex items-start justify-between">
            <div class="flex-1">
                <!-- Destination -->
                <div class="flex items-center gap-3 mb-2">
                    <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-100">
                        {{ booking.destination }}
                    </h3>
                    <StatusBadge :status="booking.status" />
                </div>

                <!-- Date and Travelers -->
                <div class="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
                    <span>{{ formattedDateRange }}</span>
                    <span class="text-slate-300 dark:text-slate-600">·</span>
                    <span>{{ travelersText }}</span>
                </div>

                <!-- Awaiting-payment CTA -->
                <p
                    v-if="booking.status === 'pending_payment'"
                    class="mt-2 text-sm text-amber-600 dark:text-amber-400"
                >
                    Your search fee payment wasn't completed — open this request
                    to finish paying and submit it.
                </p>
            </div>

            <!-- Action Button -->
            <button
                @click.stop="openBooking"
                class="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors relative"
            >
                <Icon icon="arrow-up-right" :width="20" :height="20" />
                <span
                    v-if="hasNotification"
                    class="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"
                ></span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { router } from '@inertiajs/vue3';
import Icon from '@/components/ui/icon/icon.vue';
import StatusBadge from '@/components/award-bookings/status-badge.vue';

const props = defineProps({
    booking: {
        type: Object,
        required: true,
    },
});

const formattedDateRange = computed(() => {
    if (props.booking.start_date && props.booking.end_date) {
        return `${props.booking.start_date} – ${props.booking.end_date}`;
    }
    if (props.booking.start_date) {
        return props.booking.start_date;
    }
    return 'Dates TBD';
});

const travelersText = computed(() => {
    const count = props.booking.travelers_count || 1;
    return `${count} traveler${count !== 1 ? 's' : ''}`;
});

const hasNotification = computed(() => {
    return props.booking.has_notification || false;
});

const openBooking = () => {
    router.visit(`/award-bookings/${props.booking.id}`);
};
</script>
